document.addEventListener("DOMContentLoaded", () => {

const bar = document.getElementById("sticky-atc");

if(!bar) return;

window.addEventListener("scroll",()=>{

if(window.scrollY>500){

bar.classList.add("show");

}else{

bar.classList.remove("show");

}

});

document.getElementById("sticky-atc-btn").addEventListener("click",function(){

const id=this.dataset.variant;

fetch("/cart/add.js",{

method:"POST",

headers:{

"Content-Type":"application/json"

},

body:JSON.stringify({

id:id,

quantity:1

})

})

.then(r=>r.json())

.then(()=>{

document.dispatchEvent(new CustomEvent("cart:refresh"));

window.location="/checkout";

});

});

});